import { useContext } from 'react'
import AppContext from '../context/appContext'
import { userRoles } from '../utils/userRoles'

// Enumerated rather than `!== Analyst`: AppContext seeds userRoleSelected as {}, so a deny-list
// would grant edit access on every render before Auth0 resolves the role.
const exclusionAreaEditorRoles: string[] = [
  userRoles.Admin,
  userRoles.Auditor,
  userRoles.FieldTechnician,
  userRoles.DataScientist,
  userRoles.GISTechnician,
]

// More permissive than useUserRole on purpose: exclusion areas stay editable after the plan exists
// and while a monitoring period is blocked, because the API rejects exactly the writes that overlap
// a blocked carbon instance. Re-adding plan or blocked-period gating here would hide edits the
// server would have accepted.
export const useCanEditExclusionAreas = (): boolean => {
  const { userRoleSelected } = useContext(AppContext)

  return exclusionAreaEditorRoles.includes(userRoleSelected)
}
